import type { GameDefinition } from './types';

interface GameModule {
  default: GameDefinition;
}

const modules = import.meta.glob<GameModule>('../games/*/game.ts', {
  eager: true,
});

export const games = Object.values(modules)
  .map((module) => module.default)
  .sort((left, right) => left.title.localeCompare(right.title, 'ko'));

